const PaymentTypes = [{
  value: 'CREDIT_CARD',
  label: 'cc'
}, {
  value: 'ACH',
  label: 'ach'
}, {
  value: 'CHECK',
  label: 'check'
}];
const DiscountCodeTypes = [{
  value: 'FIXED',
  label: 'Fixed'
}, {
  value: 'PERCENT',
  label: '%'
}];
module.exports = {
  PaymentTypes,
  DiscountCodeTypes
};